import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import notistack from 'modules/core/notistack';
import { Modal } from 'react-bootstrap';
import DataGrid, { Column, Scrolling } from 'devextreme-react/data-grid';
import { getAppointmentDetailsById } from '../services/appointment.service';
import { formatDateToIST } from 'helpers/dateFormat';

interface ActionButtonProp {
    selectedId: string | number;
}

const ActionButton: React.FC<ActionButtonProp> = ({ selectedId }) => {
    const [showAppointmentDetails, setShowAppointmentDetails] = useState(false);
    const [appointmentDetails, setAppointmentDetails] = useState<any[]>([]);
    const [errMsg, setErrMsg] = useState<string>('');


    const getAvailableAppointmentDetails = async () => {
        try {
            const response: any = await getAppointmentDetailsById({ id: selectedId });
            if (response.status === 200) {
                setAppointmentDetails([response.data]);
                setErrMsg('');
                setShowAppointmentDetails(true);
            } else if (response.status === 400) {
                setErrMsg(response?.message ?? '');
                setAppointmentDetails(response.data || []);
                setShowAppointmentDetails(true);
            }
        } catch (error: any) {
            notistack.error(error.message);
        }
    };

    return (
        <div>
            <button
                className="btn btn-sm action-btn"
                title="View details"
                onClick={getAvailableAppointmentDetails}
            >
                <FontAwesomeIcon icon={faEye} className="ml-2" />
            </button>

            <Modal
                size="lg"
                show={showAppointmentDetails}
                onHide={() => {
                    setShowAppointmentDetails(false);
                    setAppointmentDetails([]);
                    setErrMsg('');
                }}
                backdrop="static"
                centered
            >
                <Modal.Header closeButton>
                    <div>
                        <Modal.Title>Appointment Details</Modal.Title>
                        {errMsg && <h6 className="text-danger mt-2 mb-0">{errMsg}</h6>}
                    </div>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        <DataGrid
                            dataSource={appointmentDetails}
                            keyExpr="id"
                            showBorders={true}
                            columnAutoWidth={true}
                            showRowLines={true}
                            rowAlternationEnabled={true}
                            noDataText="No appointment details available"
                        >
                            <Scrolling mode="standard" useNative scrollByContent scrollByThumb />
                            <Column
                                dataField="appointmentArn"
                                caption="Appointment No."
                                width={"180px"}
                            />

                            <Column
                                dataField="guestName"
                                caption="Guest Name"
                                width={"200px"}
                            />

                            <Column
                                dataField="guestMobile"
                                caption="Guest Mobile No."
                                width={"150px"}
                            />

                            <Column
                                dataField="guestEmail"
                                caption="Guest Email"
                                width={"250px"}
                            />

                            <Column
                                dataField="channel"
                                caption="Channel"
                                width={"120px"}
                            />

                            <Column
                                dataField="appointmentType"
                                caption="Appointment Type"
                                width={"220px"}
                            />

                            <Column
                                dataField="slotDate"
                                caption="Slot Date"
                                width={"240px"}
                                allowFiltering={false}
                                calculateDisplayValue={(rowData) => formatDateToIST(rowData.slotDate)}
                            />

                            <Column
                                dataField="slotStartTime"
                                caption="Start Time"
                                width={"120px"}
                            />

                            <Column
                                dataField="slotEndTime"
                                caption="End Time"
                                width={"120px"}
                            />

                            <Column
                                dataField="status"
                                caption="Status"
                                width={"120px"}
                            />

                            <Column
                                dataField="eventType"
                                caption="Event Type"
                                width={"140px"}
                            />

                            <Column
                                dataField="createdOnUtc"
                                caption="Created On"
                                allowFiltering={false}
                                calculateDisplayValue={(rowData) =>
                                    formatDateToIST(rowData.createdOnUtc)
                                }
                                width={"220px"}
                                sortOrder="desc"
                            />

                        </DataGrid>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default ActionButton;
